import { AlphaYCircleIcon } from './AlphaYCircleIcon';

/**
 * author: Contributors
 * id 07D04396-8CE9-47A0-80BF-9D7055655F81
 * name alpha-y-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-y-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterYCircleIcon = AlphaYCircleIcon;
export default LetterYCircleIcon